/**
 * Inbox frame overlay: brand coins of every inbound channel, hanging over the
 * window's bottom-right edge. Hidden while a Vorgang detail is open.
 */
"use client";

import type { ReactNode } from "react";

import { useTranslations } from "next-intl";
import { ChannelLogoRow } from "./channel-logo-row";
import { useInboxUi } from "./inbox-ui-context";

export function WhatsAppIcon(props: { readonly size?: number }): ReactNode {
  const size: number = props.size ?? 14;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      style={{ display: "block" }}
      aria-hidden="true"
    >
      <path d="M12.04 2c-5.46 0-9.91 4.45-9.91 9.91 0 1.75.46 3.45 1.32 4.95L2 22l5.25-1.38c1.45.79 3.08 1.21 4.79 1.21h.01c5.46 0 9.9-4.45 9.9-9.91 0-2.65-1.03-5.14-2.9-7.01A9.82 9.82 0 0 0 12.04 2zm0 18.15h-.01c-1.53 0-3.03-.41-4.34-1.19l-.31-.18-3.23.85.86-3.15-.2-.32a8.21 8.21 0 0 1-1.26-4.36c0-4.54 3.7-8.23 8.25-8.23 2.2 0 4.27.86 5.82 2.42a8.18 8.18 0 0 1 2.41 5.82c0 4.54-3.7 8.24-8.24 8.24zm4.52-6.16c-.25-.12-1.47-.72-1.69-.81-.23-.08-.39-.12-.56.13-.16.24-.64.8-.79.97-.14.16-.29.18-.54.06-.25-.12-1.05-.39-1.99-1.23-.74-.66-1.23-1.48-1.38-1.73-.14-.25-.02-.38.11-.51.11-.11.25-.29.37-.43.12-.15.16-.25.25-.42.08-.16.04-.31-.02-.43-.06-.12-.56-1.35-.77-1.84-.2-.48-.41-.42-.56-.43h-.48c-.16 0-.43.06-.66.31-.23.25-.86.85-.86 2.07 0 1.22.89 2.41 1.01 2.57.12.17 1.75 2.67 4.24 3.74.59.26 1.05.41 1.41.52.59.19 1.13.16 1.56.1.48-.07 1.47-.6 1.68-1.18.21-.58.21-1.07.14-1.18-.06-.1-.22-.16-.47-.29z" />
    </svg>
  );
}

export function InboxChannelsCallout(): ReactNode {
  const t = useTranslations("marketing.moduleInboxChannelsCallout");
  const { inVorgangDetail } = useInboxUi();
  if (inVorgangDetail) return null;

  // i18n-exempt: brand and protocol names stay as written in every locale
  const brands = { outlook: "Outlook", gmail: "Gmail", imap: "IMAP", whatsapp: "WhatsApp" } as const;
  return (
    <ChannelLogoRow
      items={[
        { channel: "outlook", label: brands.outlook },
        { channel: "gmail", label: brands.gmail },
        { channel: "imap", label: brands.imap },
        { channel: "whatsapp", label: brands.whatsapp },
        { channel: "portal", label: t("kundenportal") },
      ]}
      style={{ position: "absolute", right: 28, bottom: -36, zIndex: 35 }}
    />
  );
}
